import { useEffect, useRef } from "react";
import { useParams, Outlet } from "react-router-dom";
import { useTenant } from "../context/TenantContext.jsx";
import { normalizeCompanyIdentifier } from "../utils/companyIdentifier";

/**
 * TenantRouteWrapper Component
 * Wraps tenant routes and sets the tenant from URL
 */
const TenantRouteWrapper = () => {
  const { tenantName: urlTenantName } = useParams();
  const { setTenant } = useTenant();
  const hasSetTenant = useRef(false);

  useEffect(() => {
    // Only set tenant once per mount to prevent loops
    if (hasSetTenant.current) return;

    if (urlTenantName) {
      hasSetTenant.current = true;
      // Just set the tenant from URL - no mismatch navigation
      setTenant(normalizeCompanyIdentifier(urlTenantName));
    }
  }, [urlTenantName, setTenant]);

  // Render the nested routes
  return <Outlet />;
};

export default TenantRouteWrapper;
